import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Debounce from "@saleor/components/Debounce";
import React from "react";

export interface DropOffSearchInputProps {
  placeholder: string;
  initialSearch: string;
  onSearchChange: (text: string) => void;
}

const DropOffSearchInput: React.FC<DropOffSearchInputProps> = props => {
  const { placeholder, initialSearch, onSearchChange } = props;

  const [search, setSearch] = React.useState(initialSearch);
  React.useEffect(() => setSearch(initialSearch), [initialSearch]);

  return (
    <Debounce debounceFn={onSearchChange}>
      {debounceSearchChange => {
        const handleSearchChange = (event: React.ChangeEvent<any>) => {
          const value = event.target.value;
          setSearch(value);
          debounceSearchChange(value);
        };

        return (
          <FormControl variant="outlined" style={{ width: "100%" }}>
            <InputLabel htmlFor="outlined-adornment-search-available-stores">
              {placeholder}
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-search-available-stores"
              type="text"
              value={search}
              onChange={handleSearchChange}
              endAdornment={
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              }
              labelWidth={70}
            />
          </FormControl>
        );
      }}
    </Debounce>
  );
};

DropOffSearchInput.displayName = "DropOffSearchInput";
export default DropOffSearchInput;
